import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDateInput]',
  standalone: false,
})
export class DateInputDirective {
  private readonly FORMAT = '  /  /    ';

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('focus')
  onFocus() {
    if (!this.el.nativeElement.value) {
      this.el.nativeElement.value = this.FORMAT;
    }
    this.el.nativeElement.setSelectionRange(0, 0);
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement;
    const value = input.value.replace(/[^0-9]/g, '');
    let formatted = this.FORMAT;
    let cursorPos = input.selectionStart || 0;

    for (let i = 0; i < value.length && i < 8; i++) {
      const char = value.charAt(i);
      if (i < 2)
        formatted =
          formatted.substring(0, i) + char + formatted.substring(i + 1);
      else if (i < 4)
        formatted =
          formatted.substring(0, i + 1) + char + formatted.substring(i + 2);
      else
        formatted =
          formatted.substring(0, i + 2) + char + formatted.substring(i + 3);
    }

    // Adjust cursor position
    if ((event as InputEvent).inputType === 'deleteContentBackward') {
      cursorPos = Math.max(0, cursorPos);
    } else {
      cursorPos = formatted.indexOf(' ', cursorPos);
      if (cursorPos === -1) cursorPos = formatted.length;
    }

    input.value = formatted;
    input.setSelectionRange(cursorPos, cursorPos);

    // If the field is effectively empty, force cursor to the left
    if (formatted === this.FORMAT) {
      input.setSelectionRange(0, 0);
    }
  }

  @HostListener('blur')
  onBlur() {
    if (this.el.nativeElement.value.replace(/[^0-9]/g, '').length === 0) {
      this.el.nativeElement.value = '';
    }
  }
}
